import { AxiosError } from 'axios';

export const isAxiosError = (error: unknown): error is AxiosError =>
  (error as AxiosError).isAxiosError !== false;
